import {API_URL} from "common/const";
import {fetchApiClient} from "common/fetchApiClient";
import {AxiosError} from "axios";
import UnauthorizedError from "api/errors/UnauthorizedError";
import User from "model/User";


const getUsers = async (leagueId: number, token: string | undefined): Promise<User[]> => {
    const apiClient = fetchApiClient(token);

    return await apiClient.get<User[]>(`${API_URL}/users/${leagueId}`)
        .then(response => {
            return response.data;
        }).catch((error: AxiosError) => {
            console.log(`Error fetching users for League(${leagueId})`, error);
            if (!!error.response && error.response.status === 403) {
                throw new UnauthorizedError();
            }
            throw error;
        });
}

export default getUsers;
